import React, { Fragment } from 'react';
import { jsxs as _jsxs } from "react/jsx-runtime";
export const createSeparatedList = (list, separator) => list.filter(item => item).map((item, index) => /*#__PURE__*/_jsxs(Fragment, {
  children: [!!index && separator, item]
}, index));